import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import Select from "react-select";
import ApiCallServices from "../../../../services/ApiCallServices";
import { END_POINTS } from "../../../../services/endpoint/endPoint";
import button from "../../../button.module.css";
import SuggestionsList from "./child/SuggestionsList";

const Suggestions = () => {
  const initialState = {
    suggestion: "",
    category: "",
  };

  const [selectedPrevillage, setSelectedPrevillage] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [newSuggestion, setNewSuggestion] = useState(initialState);
  const [search, setSearch] = useState("");
  const [suggestionRole, setSuggestionRole] = useState([]);
  const [selectedSuggestionRole, setSelectedSuggestionRole] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [errors, setErrors] = useState({});
  const [showHideModal, setShowHideModal] = useState(false);
  const [showHideModal1, setShowHideModal1] = useState(false);
  const [loader, setLoader] = useState(false);
  const [sortingColumn, setSortingColumn] = useState(null);
  const [sortingOrder, setSortingOrder] = useState("asc");

  useEffect(() => {
    fetchSuggestionRoles();
  }, []);

  const updateStatus = async (id, status) => {
    try {
      const res = await ApiCallServices.create(
        END_POINTS.updateSuggestionStatus,
        {
          id,
          status,
        }
      );

      if (res.status === 200) {
        toast.success(res.data.message || "Status updated", {
          position: "top-right",
        });
        getSuggestionsTableData();
      }
    } catch (error) {
      toast.error(error.response?.data?.error || "Failed to update status", {
        position: "top-right",
      });
    }
  };

  const getSuggestion = async (id) => {
    try {
      const res = await ApiCallServices.getlisting(
        `${END_POINTS.getSuggestionById}/${id}`
      );
      if (res.status === 200) {
        const { category, suggestion } = res.data.message;

        const matchedCategory = suggestionRole.find(
          (role) => role.id === category
        );

        setNewSuggestion({
          category: matchedCategory?.id || "", 
          suggestion: suggestion || "",
          id,
        });
        setIsEditMode(true);
        setShowHideModal(true);
        document.body.style = "overflow: hidden";
      }
    } catch (error) {
      toast.error("Failed to fetch suggestion details", {
        position: "top-right",
      });
    }
  };

  const fetchSuggestionRoles = async () => {
    try {
      const res = await ApiCallServices.getlisting(
        END_POINTS.suggestionCategoryListData
      );
      if (res.status === 200) {
        setSuggestionRole(res.data.data);
      }
    } catch (error) {
      toast.error("Failed to load suggestion category", {
        position: "top-right",
      });
      console.error("Error fetching suggestion category", error.response);
    }
  };

  const getSuggestionsTableData = async () => {
    setLoader(true);
    const data = {
      name: search,
      suggestionType: selectedSuggestionRole?.id,
      sortingcolumn: sortingColumn,
      sortingorder: sortingOrder,
    };
    try {
      const res = await ApiCallServices.create(
        END_POINTS.suggestionsTableData,
        data
      );
      if (res.status === 200) {
        setTableData(res.data.data);
      }
    } catch (error) {
      toast.error(error.response?.data?.error || "Error fetching data", {
        position: "top-right",
      });
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getSuggestionsTableData();
  }, [search, selectedSuggestionRole, sortingColumn, sortingOrder]);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setNewSuggestion({ ...newSuggestion, [name]: value });
  };

  const validateForm = (prev) => {
    const errors = {};
    if (!newSuggestion?.category) errors.category = "Category is required";
    if (!newSuggestion?.suggestion)
      errors.suggestion = "Suggestion is required";
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const prev = selectedPrevillage.map((item) => item.value);
    if (!validateForm(prev)) return;

    const obj = { ...newSuggestion, privilege: prev };

    try {
      const res = isEditMode
        ? await ApiCallServices.create(END_POINTS.updateSuggestion, obj)
        : await ApiCallServices.create(END_POINTS.createSuggestion, obj);

      if (res.status === 200) {
        toast.success(res.data.message, { position: "top-right" });
        resetForm();
        getSuggestionsTableData();
      }
    } catch (error) {
      toast.error(error.response?.data?.error || "Operation failed", {
        position: "top-right",
      });
    }
  };

  const resetForm = () => {
    setIsEditMode(false);
    setNewSuggestion(initialState);
    setSelectedPrevillage([]);
    setShowHideModal(false);
    document.body.removeAttribute("style");
    setErrors({});
  };

  return (
    <>
      <ToastContainer />
      <div className="container-fluid">
      <div className='filter-wraper justify-content-between'>
          <div className='d-flex align-items-center fields'>
              <h3>Manage Suggestions</h3>
          </div>
      </div>
        <div className="filter-wraper d-flex justify-content-between">
          <div className="d-flex align-items-center fields">
            <div className="form-group search-icon">
              <input
                type="text"
                className="form-control"
                onChange={(e) =>
                  setSearch(e.target.value.length > 1 ? e.target.value : "")
                }
                placeholder="Search suggestions"
              />
            </div>
            <div className="form-group custome-select">
              <Select
                placeholder="Select Category"
                isClearable={true}
                value={selectedSuggestionRole}
                onChange={setSelectedSuggestionRole}
                options={suggestionRole}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
              />
            </div>
          </div>
          <div className="form-group d-flex justify-content-end">
            <button
              type="button"
              className={`${button.btn} ${button.btnDarkBlue}`}
              onClick={() => {
                setShowHideModal(true);
                document.body.style = "overflow: hidden";
              }}
            >
              Add New Suggestion
            </button>
          </div>
        </div>

        <SuggestionsList
          tableData={tableData}
          getSuggestion={getSuggestion}
          search={search}
          onSort={(col) => setSortingColumn(col)}
          updateStatus={updateStatus}
          loader={loader}
          addsubSuggestion={() => {}}
        />
      </div>

      <div className={`modal form-modal ${showHideModal ? "show" : ""}`}>
        <div className="modal-dialog modal-md modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                {isEditMode ? "Update Suggestion" : "Create New Suggestion"}
              </h4>
              <i
                className="fa-regular fa-circle-xmark close-icon"
                onClick={resetForm}
              ></i>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="form-wraper">
                  <div className="form-group">
                    <label>
                      Category <span className="astric">*</span>
                    </label>
                    <select
                      className="form-control"
                      name="category"
                      value={newSuggestion.category}
                      onChange={handleInput}
                    >
                      <option value="" disabled>
                        Select Category
                      </option>
                      {suggestionRole.map((role) => (
                        <option key={role.id} value={role.id}>
                          {role.name}
                        </option>
                      ))}
                    </select>
                    {errors?.category && (
                      <div className="input-error">{errors.category}</div>
                    )}
                  </div>

                  <div className="form-group">
                    <label>
                      Suggestion <span className="astric">*</span>
                    </label>
                    <textarea
                      placeholder="Enter Suggestion"
                      name="suggestion"
                      value={newSuggestion.suggestion}
                      onChange={handleInput}
                      className="form-control"
                      rows={4}
                    />
                    {errors?.suggestion && (
                      <div className="input-error">{errors.suggestion}</div>
                    )}
                  </div>

                  <div className="text-end">
                    <button
                      type="submit"
                      className={`${button.btn} ${button.btnBlue}`}
                    >
                      {isEditMode ? "Update" : "Save"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`${showHideModal || showHideModal1 ? "overlay" : ""}`}
      ></div>
    </>
  );
};

export default Suggestions;
